import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

/**
 * PD-17398 — someone who does not get a scheduled report even though a team,
 * role or address list includes them: added by the owner, or by the person
 * themselves through "Stop sending me this" (`reason: optOut`). Applied last.
 */
@Index('idx_report_schedule_except_schedule', ['fkReportScheduleId'])
@Entity('report_schedule_except')
export class ReportScheduleExceptEntity extends BaseEntity {
	@Column('int', { name: 'fk_report_schedule__id', unsigned: true })
	public fkReportScheduleId!: number;

	@Column('int', { name: 'fk_user__id', unsigned: true, nullable: true })
	public fkUserId!: number | null;

	@Column('varchar', { name: 'email', length: 255, nullable: true })
	public email!: string | null;

	/** `owner` (added in the editor) or `optOut` (the person stopped it). */
	@Column('varchar', { name: 'reason', length: 20, default: 'owner' })
	public reason!: string;
}
